function _extendIndicatorItem(indicatorItem) {
    indicatorItem.getOverflowLevel = function () {
        if (this.data.OverFlow) {
            return this.data.OverFlowType === 'MIN' ? 'low' : 'high'
        }
        return 'ok'
    }

    indicatorItem.getShortAdvice = function (hasPurifier) {
        const level = this.getOverflowLevel()
        if (level === 'low') {
            return hasPurifier
                ? this.resource.ShortAdviceLowThresholdWithPurifier
                : this.resource.ShortAdviceLowThresholdNoPurifier
        }
        if (level === 'high') {
            return hasPurifier
                ? this.resource.ShortAdviceHighThresholdWithPurifier
                : this.resource.ShortAdviceHighThresholdNoPurifier
        }
        return null
    }

    indicatorItem.getLongAdvice = function (hasPurifier) {
        const level = this.getOverflowLevel()
        if (level === 'low') {
            return hasPurifier
                ? this.resource.LongAdviceLowThresholdWithPurifier
                : this.resource.LongAdviceLowThresholdNoPurifier
        }
        if (level === 'high') {
            return hasPurifier
                ? this.resource.LongAdviceHighThresholdWithPurifier
                : this.resource.LongAdviceHighThresholdNoPurifier
        }
        return null
    }
}

export function ExtendIndicatorItemList(indicatorItems) {
    for (let item of indicatorItems) {
        _extendIndicatorItem(item)
    }

    indicatorItems.getGlobalOverflowLevel = function () {
        for (let item of this) {
            const level = item.getOverflowLevel()
            if (level !== 'ok') {
                return level
            }
        }
        return 'ok'
    }

    indicatorItems.getGlobalShortAdvice = function () {
        for (let item of this) {
            const level = item.getOverflowLevel()
            if (level !== 'ok') {
                return item.getShortAdvice()
            }
        }
        return null
    }

    indicatorItems.getLastUpdateDate = function () {
        for (let item of this) {
            const d = item.data.Date
            if (d) {
                return d
            }
        }
        return new Date()
    }
}


// WEBPACK FOOTER //
// ./src/IndicatorItems.js